var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe.components/common/modal/modal.indra.service';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { Router } from '@angular/router';
import { takeWhile } from 'rxjs/operators';
var INDRAConfirmModalComponent = /** @class */ (function (_super) {
    __extends(INDRAConfirmModalComponent, _super);
    function INDRAConfirmModalComponent(store, modalService, router) {
        var _this = _super.call(this, modalService) || this;
        _this.store = store;
        _this.modalService = modalService;
        _this.router = router;
        _this.title$ = _this.store.select(fromStore.getConfirmModalTitle);
        _this.bodyMsg$ = _this.store.select(fromStore.getConfirmModalBodyMsg);
        _this.okLabel$ = _this.store.select(fromStore.getConfirmModalOKLabel);
        _this.cancelLabel$ = _this.store.select(fromStore.getConfirmModalCancelLabel);
        //isAccent when true confirm button is red, if false uses the primary color
        _this.isAccent$ = _this.store.select(fromStore.getConfirmModalIsAccent);
        _this.isAlive = true;
        _this.TYPE = 'dialog';
        return _this;
    }
    INDRAConfirmModalComponent.prototype.ngOnInit = function () {
        this.loadHtml();
    };
    INDRAConfirmModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    INDRAConfirmModalComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    INDRAConfirmModalComponent.prototype.cancel = function () {
        this.store.dispatch(new ConfirmModalActions.PutConfirm('cancel'));
        this.closeModal();
    };
    INDRAConfirmModalComponent.prototype.confirm = function () {
        this.store.dispatch(new ConfirmModalActions.PutConfirm('ok'));
        this.closeModal();
        //this.router.navigate(['/booking']);
    };
    INDRAConfirmModalComponent.prototype.loadHtml = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.bodyMsg$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (data) {
                    _this.modalBodyDiv.nativeElement.innerHTML = data;
                });
                return [2 /*return*/];
            });
        });
    };
    return INDRAConfirmModalComponent;
}(AbstractModalContentComponent));
export { INDRAConfirmModalComponent };
